export const GET_CASINO_COLLECTIONS_EXECUTIONS_SUCCESS =
  "@casinos/GET_CASINO_COLLECTIONS_EXECUTIONS_SUCCESS";
export const GET_CASINO_COLLECTIONS_EXECUTIONS_START =
  "@casinos/GET_CASINO_COLLECTIONS_EXECUTIONS_START";
export const GET_CASINO_COLLECTIONS_EXECUTIONS_FAIL =
  "@casinos/GET_CASINO_COLLECTIONS_EXECUTIONS_FAIL";
